import React,{useState,useRef,useEffect} from 'react'
import {Card,Typography,TextField,Button} from '@mui/material'
import {postEnquiry} from '../backend/api'
import setStateAsync from '../backend/setStateAsync'
import LoadingComponent from './loadingComponent'
import ErrorComponent from './errorComponent'
import DoneIcon from '@mui/icons-material/Done';



export default function InquireProperty(props){

    // propertyID = the backend integer id (optional, for linking to a property)
    const propertyID = props.propertyID
    const [loading,toggleLoading] = useState(false)
    const [error,toggleError] = useState(false)
    const [success,toggleSuccess] = useState(false)
    const mounted = useRef(true)

    const [name,setName] = useState('')
    const [email,setEmail] = useState('')
    const [phone,setPhone] = useState('')
    const [message,setMessage] = useState('')

    const ERRORTEXT = `Could not send request. Please check your details and try again.`

    useEffect(()=>{
        mounted.current = true
        return()=> mounted.current = false
    },[])

    async function submitEnquiry(){
        try{
            setStateAsync(true,toggleLoading,mounted.current)
            setStateAsync(false,toggleError,mounted.current)
            const enquiry = {
                name,
                email,
                phone,
                message,
                ...(propertyID ? { property: propertyID } : {})
            }
            await postEnquiry(enquiry)
            setStateAsync(true,toggleSuccess,mounted.current)
        }catch(e){
            setStateAsync(true,toggleError,mounted.current)
        }finally{
            setStateAsync(false,toggleLoading,mounted.current)
        }
    }

    function isValid(){
        return name.trim().length > 0 && email.trim().length > 0 && message.trim().length > 0
    }

    function initializeState(){
        setName('')
        setEmail('')
        setPhone('')
        setMessage('')
        toggleSuccess(false)
    }

    return(
        <Card sx = {{display:'flex',flexDirection:'column', alignItems:'center',backgroundColor:'background.lightSecondary' , py:2,px:2,mx:2,...props.style}}>

           {loading ? <LoadingComponent /> : error ? <ErrorComponent errorText = {ERRORTEXT} onClick = {()=> toggleError(false)} /> : success ? <>
            <DoneIcon />
            <Typography variant = 'h6'>Request Received!</Typography>
            <Typography variant = 'body2' textAlign='center'>You will receive an email soon about the next steps.</Typography>
            <Button onClick = {()=> initializeState()}>Submit another enquiry</Button>
            </> :
           <>
           <Typography variant = 'h6'>Enquire about this property</Typography>
            <TextField value = {name} onChange = {e=> setName(e.target.value)} sx = {styles.textField} type = 'text' label = 'Full Name' id = 'name' required />
            <TextField value = {email} onChange = {e=> setEmail(e.target.value)} sx = {styles.textField} type = 'email' label = 'Email Address' id = 'email' required />
            <TextField value = {phone} onChange = {e=> setPhone(e.target.value)} sx = {styles.textField} type = 'tel' label = 'Phone (optional)' id = 'phone' />
            <TextField value = {message} onChange = {e=> setMessage(e.target.value)} sx = {styles.textField} type = 'text' label = 'Message' id = 'message' multiline rows={3} required />
            <Button disabled={!isValid()} onClick = {()=> submitEnquiry()}>Submit</Button>
            </>
    }
        </Card>
    )
}

const styles = {
    textField:{
        my:2,
        width:'100%'
    }
}
